<template>
  <div class="main_center" style="margin: 0 0; padding-top: 8px;">
    <div class="content" style="padding: 16px 16px 5px 16px;">
      <el-form ref="form" :model="form" label-width="100px">
        <el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="年份：">
                <el-select v-model="form.year" value-key="value" style="width: 100%" @change="yearsChange">
                  <el-option v-for="(item, index) in yearsList" :key="index" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="关键字：" props="searchKey">
                <el-input v-model="form.searchKey" clearable placeholder="请输入项目编号，项目名称关键字" @keyup.enter.native="searchBtn"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="">
                <div>
                  <el-button plain size="small" type="primary" @click="reflash">重置</el-button>
                  <el-button size="small" type="primary" @click="searchBtn">搜索</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-form>

      <space :left="-16" :right="-16" :bottom="16" />

      <el-table
        :data="tableData"
        v-loading="dataListLoading"
        ref="expertExtractTable"
        :height="tableMaxHeight"
        stripe
        border
        @sort-change="sortChange"
      >
        <el-table-column label="序号" type="index" :index="indexMethod" width="50" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="操作" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" title="查看评审进度" @click="handleClickRouter(scope.row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="招标项目编号/标段编号"
          prop="tradePlatfTenderProjectCode"
          align="left"
          min-width="300"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="招标项目名称/标段名称"
          prop="tenderProjectName"
          align="left"
          min-width="300"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column label="项目所属交易中心" prop="tradeName" align="left" width="200" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.tradeName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="定标时间" prop="decisionStartTime" align="left" width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="定标地点" prop="decisionAddress" align="left" min-width="300" :show-overflow-tooltip="true"></el-table-column>
      </el-table>
      <pagination
        class="limit"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        :page.sync="pageIndex"
        :limit.sync="pageSize"
        @pagination="paginationChange"
      >
      </pagination>
    </div>
  </div>
</template>

<script>
import space from "../../common/components/space.vue";
import Pagination from "@/components/Pagination";
import { nearSixYearsList } from "@/utils/index";

export default {
  name: "ScalingExpertInfo",
  components: {
    space,
    Pagination,
  },
  data() {
    return {
      form: {
        year: new Date().getFullYear(),
        searchKey: "",
      },
      yearsList: [],
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      dataListLoading: false,
      tableMaxHeight: document.documentElement.clientHeight - 275,
      inputHtml: "",
      sortParams: {
        prop: "",
        order: "",
      },
    };
  },
  methods: {
    ifmove() {
      const hasBtnPermisson = false;
      let tableMaxHeight = document.documentElement.clientHeight - 357 + (hasBtnPermisson ? 0 : 41);
      this.pageSize = parseInt(tableMaxHeight / 50) || 1;
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight;
      });
    },
    searchBtn() {
      this.pageIndex = 1;
      this.getList();
    },
    reflash() {
      this.form = {
        year: new Date().getFullYear(),
        searchKey: "",
      };
      this.pageIndex = 1;
      this.getList();
    },
    yearsChange(val) {
      this.yearsList = nearSixYearsList(val);
      this.getList();
    },
    getList() {
      this.dataListLoading = true;
      const params = {
        page: this.pageIndex,
        rows: this.pageSize,
        searchKey: this.form.searchKey,
        filter: {
          auditYear: this.form.year,
        },
      };
      this.$http.post(`/decisioncommitteebuild/list`, params).then((res) => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
        this.dataListLoading = false;
      }).catch((err) => {
        this.tableData = [];
        this.total = 0;
        this.dataListLoading = false;
        this.$message.error(err);
      });
    },
    sortChange({ column, prop, order }) {
      this.sortParams.prop = prop || column.prop;
      this.sortParams.order = order || column.order;
      this.getList();
    },
    paginationChange({ page, limit }) {
      this.pageIndex = page;
      this.pageSize = limit;
      this.getList();
    },
    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },
    handleClickRouter(item) {
      this.$router.push({
        name: "scalingExpertInfoDetail",
        query: {
          id: item.id,
        },
      });
    },
  },
  activated() {
    this.getList();
  },
  mounted() {
    this.yearsList = nearSixYearsList(this.form.year);
    this.ifmove();
    let resizeTag = true;
    let that = this;
    window.onresize = () => {
      if (resizeTag) {
        //防抖动
        that.ifmove();
        resizeTag = false;
        setTimeout(() => {
          resizeTag = true;
        }, 1000);
      }
    };
  },
};
</script>
